import React, { createContext, useContext, useEffect, useState } from 'react';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const ContentContext = createContext({ content: {}, loading: true });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BACKEND}/api/content`)
      .then((r) => (r.ok ? r.json() : {}))
      .then((d) => setContent(d || {}))
      .catch(() => setContent({}))
      .finally(() => setLoading(false));
  }, []);

  return (
    <ContentContext.Provider value={{
      content,
      loading,
      img: (key, fallback) => resolveImg(content.images?.[key]) || fallback,
      txt: (page, key, fallback) => {
        const v = content.pages?.[page]?.[key];
        return v === undefined || v === '' ? fallback : v;
      },
    }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);

// Resolve an image value to a full URL (handles uploaded /api/files paths)
export const resolveImg = (val) => {
  if (!val) return val;
  if (typeof val !== 'string') return val;
  if (val.startsWith('/api/')) return `${BACKEND}${val}`;
  return val;
};
